import { RefreshCw } from "lucide-react";
import { Button } from "../ui";
import { useFeedbackInbox } from "./hooks";
import { FeedbackDetail, FeedbackFilters, FeedbackList } from "./feedback";

type FeedbackInboxProps = {
  onOpenCountChange?: (count: number) => void;
};

export default function FeedbackInbox({
  onOpenCountChange,
}: FeedbackInboxProps) {
  const {
    filter,
    setFilter,
    items,
    selectedId,
    setSelectedId,
    selected,
    resolutionNote,
    setResolutionNote,
    loading,
    detailLoading,
    saving,
    error,
    loadFeedback,
    handleStatusChange,
  } = useFeedbackInbox({ onOpenCountChange });

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Feedback</h2>
          <p className="text-sm text-gray-500">
            Review challenged Brian answers and record how they were handled.
          </p>
        </div>
        <Button
          type="button"
          variant="secondary"
          className="px-3"
          onClick={() => void loadFeedback()}
        >
          <RefreshCw size={14} />
          Refresh
        </Button>
      </div>

      <FeedbackFilters value={filter} onChange={setFilter} />

      {error && (
        <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600 ring-1 ring-red-200">
          {error}
        </div>
      )}

      <div className="grid gap-4 lg:grid-cols-[360px_1fr]">
        <FeedbackList
          items={items}
          loading={loading}
          selectedId={selectedId}
          onSelect={setSelectedId}
        />
        <FeedbackDetail
          feedback={selected}
          loading={detailLoading}
          resolutionNote={resolutionNote}
          saving={saving}
          onResolutionNoteChange={setResolutionNote}
          onStatusChange={(status) => void handleStatusChange(status)}
        />
      </div>
    </div>
  );
}
